var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftReverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 23,
    viewBox: "0 0 12 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7509 22.1875C10.9072 22.1884 11.0621 22.1584 11.2068 22.0993C11.3515 22.0402 11.4831 21.9532 11.5941 21.8431C11.7054 21.7327 11.7937 21.6014 11.854 21.4567C11.9143 21.312 11.9453 21.1567 11.9453 21C11.9453 20.8432 11.9143 20.688 11.854 20.5433C11.7937 20.3986 11.7054 20.2672 11.5941 20.1569L2.9253 11.5L11.5941 2.8431C11.8177 2.61949 11.9433 2.31621 11.9433 1.99998C11.9433 1.84339 11.9124 1.68834 11.8525 1.54368C11.7926 1.39902 11.7048 1.26757 11.5941 1.15685C11.4833 1.04613 11.3519 0.958302 11.2072 0.89838C11.0626 0.838459 10.9075 0.807617 10.7509 0.807617C10.4347 0.807617 10.1314 0.93324 9.9078 1.15685L0.407803 10.6569C0.2965 10.7672 0.208156 10.8986 0.147867 11.0433C0.0875797 11.188 0.0565414 11.3432 0.0565414 11.5C0.0565414 11.6567 0.0875797 11.812 0.147867 11.9567C0.208156 12.1014 0.2965 12.2327 0.407803 12.3431L9.9078 21.8431C10.0188 21.9532 10.1504 22.0402 10.295 22.0993C10.4397 22.1584 10.5946 22.1884 10.7509 22.1875Z",
    fill: "#776B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftReverseIcon);
export default __webpack_public_path__ + "static/media/left-reverse-icon.4dbb6fd5539adcd570ffe0706ff33f88.svg";
export { ForwardRef as ReactComponent };